const MonitorRamaisHome = () => import(/* webpackChunkName: "group-pabx-monitor" */ '../_views/MonitorRamaisHome')

export default [
  {
    path: 'ramais',
    component: MonitorRamaisHome,
    meta: { requiresAuth: true, permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_PABX_HABILITADO] },
    name: 'monitor',
  },
]
